import React from 'react';
import MachineDetails from './machinedetails/machinedetails';
import InstallationDetails from './installatiodetails/installationdetails';
import OptionObservation from './optionobeservation/optionobeservation';
import AdditionalDetails from './additionaldetail/additionaldetail';


class MainForm extends React.Component { 
constructor() {
  super();
  this.state = {
    dataset: []
}  

 }
 componentDidMount(){
  this.getPostDetails();
 }
 getPostDetails = () => {
	let queryParams = new URLSearchParams(window.location.search);
    let id = queryParams.get('id');
	  fetch(`http://localhost:8090/api/orders/${id}`)
        .then((response) => response.json())
        .then(data => {this.setState({ dataset: data});
        });  
}

  render(){
  return (
          <div className="container my-4">
	<ul className="breadcrumb">
<div className="row">
<div className="col-md-6">
<div className="form-group">
 <label className="form-label">Line:</label>
<input type="text" className="form-control" name="validation-email" placeholder="WWS-1" />
</div>
</div>
<div className="col-md-6">
<div className="form-group">
<label className="form-label">Machine Code </label>
		  {this.state.dataset.map((machine,i) => (  
<input type="text" key={i} className="form-control" defaultValue={machine.MACHINE_CODE} />
))}
</div>
</div>
</div>

	<div>
	<ul className="nav nav-tabs" id="myTab" role="tablist">
  <li className="nav-item" role="presentation">
    <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Machine Details</a>
  </li>
  <li className="nav-item" role="presentation">
    <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Installation Details</a>
  </li>
  <li className="nav-item" role="presentation">
    <a className="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">Option & Observation</a>
  </li>
    <li className="nav-item" role="presentation">
    <a className="nav-link" id="contact-tab1" data-toggle="tab" href="#contact1" role="tab" aria-controls="contact1" aria-selected="false">Additional Details</a>
  </li>
</ul>
</div>
</ul>
  <div className="tab-content" id="myTabContent">
  <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">{this.state.dataset.map((machine,i) => (  <MachineDetails key={i} id={machine.MACHINE_CODE}></MachineDetails> ))}</div>
  <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">{this.state.dataset.map((machine,i) => ( <InstallationDetails key={i} id={machine.MACHINE_CODE}></InstallationDetails>))}</div>
  <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">{this.state.dataset.map((machine,i) => ( <OptionObservation key={i} id={machine.MACHINE_CODE}></OptionObservation>))}</div>
  <div className="tab-pane fade" id="contact1" role="tabpanel" aria-labelledby="contact-tab1">{this.state.dataset.map((machine,i) => ( <AdditionalDetails key={i} id={machine.MACHINE_CODE}></AdditionalDetails>))}</div>
  {/* <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
    <MachineDetails id={this.state.newid}></MachineDetails></div>
  <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab"><InstallationDetails id={this.state.newid}></InstallationDetails></div>
  <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab"><OptionObservation id={this.state.newid}></OptionObservation></div>
  <div className="tab-pane fade" id="contact1" role="tabpanel" aria-labelledby="contact-tab1"><AdditionalDetails id={this.state.newid}></AdditionalDetails></div> */}
</div>

    </div>	
  );

}
}
export default MainForm;
